import React, { useState, useRef } from 'react'
import { FormattedMessage, FormattedDate } from 'react-intl'
import messages from 'i18n/messages'
import isEmpty from 'lodash/isEmpty'
import { useSelector, useDispatch } from 'react-redux'
import { Spinner, Button, Label, Form, FormGroup, Input, Alert } from 'reactstrap'
import { setBookingCode, setStepOneComplete } from 'logic/goods'
import { updateCustomerAttr } from 'logic/customers'
import { makeSelectCurOrg } from 'logic/orgs'
import ReactCodeInput from 'react-verification-code-input'
import { apiGet } from 'logic/api'
import { showMsg } from 'logic/sweetalert'

function EmailAddressForm ({ bookingCode }) {
  const dispatch = useDispatch()
  const [email, setEmail] = useState('')
  const handleSubmit = () => {
    dispatch(updateCustomerAttr('email', email))
    dispatch(setBookingCode(bookingCode))
    dispatch(setStepOneComplete())
  }
  return (
    <div className="mb-4 mt-4 p-2 email-address-form">
      <div className="container card">
        <div className="booking-code-info">
          <div className="basket-btn-wrap" />
          <div className="booking-code-wrap">
            <div className="label">
              <FormattedMessage {...messages.bookingCode} />
            </div>
            <div className="booking-code">
              <div
                className="d-flex align-items-center justify-content-end text-right"
              >
                <span>{bookingCode}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <Alert color="warning">
          <FormattedMessage {...messages.noEmailInBookingcodeDesc} />
        </Alert>
      </div>
      <h3 className="text-center"><FormattedMessage {...messages.email} /></h3>
      <Form onSubmit={handleSubmit}>
        <div className="email-form-group-wrap">
          <FormGroup>
            <Input
              type="email"
              required
              name="email"
              onChange={({ target }) => setEmail(target.value)}
              value={email}
            />
          </FormGroup>
        </div>
        <Button color="primary" block type="submit">
          <FormattedMessage {...messages.save} />
        </Button>
      </Form>
    </div>
  )
}

function ConfirmSeats ({ seat, date, title }) {
  return (
    <div>
      <div className="font-weight-bold">
        <FormattedMessage {...messages.verifyBookingCode} />
      </div>
      <div className="m-4">
        <FormattedMessage {...messages.isThisOneOfYourSeats} />
      </div>
      <div className="font-weight-bold">
        <div>{seat}</div>
        <div className="mt-4">{title}</div>
        <div className="small">
          <FormattedDate value={date} day="numeric" month="short" year="numeric" hour="numeric" minute="numeric" />
        </div>
      </div>
    </div>
  )
}
export default function ConnectGoodsWithBookingCode () {

  const dispatch = useDispatch()
  const codeInputRef = useRef()
  const [tmpBCode, setTmpBCode] = useState('')
  const [emailExists, setEmailExists] = useState(null)
  const [error, setError] = useState(false)
  const [closed, setClosed] = useState(false)
  const [loading, setLoading] = useState(false)
  const org = useSelector(makeSelectCurOrg())
  const handleResetInput = () => {
    setTmpBCode('')
    setError(false)
    codeInputRef.current.__clearvalues__()
  }
  const handleSubmit = () => handleCheckBookingCodeAndProceed(tmpBCode)
  const handleSetBookingCode = value => setTmpBCode(value)
  const handleCheckBookingCodeAndProceed = async value => {
    try {
      setLoading(true)
      const res = await apiGet(`/orders/check/code?booking_code=${value}&org_id=${org.id}`)
      const cb = ok => {
        if (!ok) return

        setEmailExists(res.email === 1)
        if (res.email) {
          dispatch(setBookingCode(value))
          dispatch(setStepOneComplete())
        }
      }
      dispatch(showMsg(
        <ConfirmSeats seat={res.info} date={res.date} title={res.title} />,
        { confirmBtnText: <FormattedMessage {...messages.yesThatsMine} />,
          cancelBtnText: <FormattedMessage {...messages.nopeTryAgain} />,
          showCancel: true,
          cb
        }
      ))
    } catch (e) {
      console.error(e)
      dispatch(setBookingCode(null))
      if (e.body && e.body.error === 'sale is closed')
        return setClosed(true)
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  const values = tmpBCode.split('')

  if (emailExists === false) return <EmailAddressForm bookingCode={tmpBCode} />

  return (
    <div className="qty-form-control-price-options open">
      <div className="text-center p-4 mt-2">
        { !isEmpty(org.portal.goods_title)
          ? <h4 className="mb-4">{org.portal.goods_title}</h4>
          : null
        }
        <Label>
          <FormattedMessage {...messages.enterBookingCode} />
        </Label>
        <div className="booking-code-desc">
          <div>
            <FormattedMessage {...messages.enterBookingCodeDesc} values={{ orgId: org.short_identifier, br: (...chunks) => <br key={`a-${Math.random(100000)}`} /> }} />
          </div>
        </div>
        <div className="mr-2" />
        <ReactCodeInput
          name="booking_code"
          ref={codeInputRef}
          className="booking-code-input"
          values={values}
          autoFocus
          loading={loading}
          onChange={handleSetBookingCode}
          onComplete={handleCheckBookingCodeAndProceed}
          value={tmpBCode}
          fields={9}
          required
        />
        { error
          ? <div className="mt-4">
              <Alert color="danger"><FormattedMessage {...messages.bookingCodeInvalid} /></Alert>
            </div>
          : null
        }
        { closed
          ? <div className="mt-4">
              <Alert color="danger"><FormattedMessage {...messages.salesClosed} /></Alert>
            </div>
          : null
        }
        <div className="mt-4">
          <Button size="lg" color="link" type="button" onClick={handleResetInput} disabled={loading}>
            <FormattedMessage {...messages.resetInput} />
          </Button>
          <Button size="lg" color="primary" type="button" onClick={handleSubmit} disabled={loading}>
            { loading
              ? <div className="d-flex align-items-center justify-content-center">
                  <Spinner color="light" className="mr-2" />
                  <FormattedMessage {...messages.checkingYourCode} />
                </div>
              : <FormattedMessage {...messages.checkCode} />
            }
          </Button>
        </div>
      </div>
    </div>
  )
}